import './CashinClosingModeClosedBet.less';
import React from 'react';
import clsx from 'clsx';
import CashinClosingOddsIcon from '../../../icons/CashinClosingOddsIcon';
import i18n from '../../../common/i18n';
import { formatDate, formatNumber } from '../../../common/util';
import { closingWrapperName, emptyDivClassesAfter, emptyDivClassesBefore } from './types';
import { useDarkTheme } from '../../../common/theme';

const CashinClosingModeClosedBet = ({ bet, mobile, currentUserTicket }) => {
    const isDarkTheme = useDarkTheme();
    return mobile ? (
        <div className={clsx('flex cashin-closing-container  mobile-top py-2 pl-2 closed')}>
            <div className="closing-icon-wrapper mobileWrap pl-10">
                <CashinClosingOddsIcon width={20} height={20} />
            </div>
            <div className="flex-2 mobileWrap">
                <span className="closing-date mobile">
                    {i18n(
                        'nui.ticketus.cashin.closing-mode.closedbet',
                        formatDate(bet.get('closeTime'), 'DD.MM.YYYY (HH:mm)')
                    )}
                </span>
            </div>
            <div className="pl-8 text-bold c-blue text-extra-bold flex mr-20 mobileWrap">
                <span>{formatNumber(bet.get('closeOdds'), 2)}</span>
            </div>
        </div>
    ) : (
        <>
            <hr className="line-breaker" />
            <div
                className={clsx('flex cashin-closing-container py-2 pl-10', {
                    closed: !isDarkTheme,
                    'cashin-closing-dark': isDarkTheme
                })}
            >
                <div className="closing-icon-wrapper portal">
                    <CashinClosingOddsIcon width={16} height={16} />
                </div>
                <div className={clsx(closingWrapperName + 'date', 'text-left')}>
                    <span className="closing-date">
                        {i18n(
                            'nui.ticketus.cashin.closing-mode.closedbet',
                            formatDate(bet.get('closeTime'), 'DD.MM.YYYY (HH:mm)')
                        )}
                    </span>
                </div>
                {emptyDivClassesBefore.map((className, index) => (
                    <div
                        className={clsx(closingWrapperName + className)}
                        key={closingWrapperName + className + index.toString()}
                    ></div>
                ))}
                <div className={clsx(closingWrapperName + 'closing')}>
                    <div className={clsx('text-bold')}>{formatNumber(bet.get('closeOdds'), 2)}</div>
                </div>
                {currentUserTicket ? <div className={clsx(closingWrapperName + 'empty current-odds')}></div> : null}
                {emptyDivClassesAfter.map(className => (
                    <div className={closingWrapperName + className} key={closingWrapperName + className}></div>
                ))}
            </div>
        </>
    );
};

export default CashinClosingModeClosedBet;
